export default "__VITE_ASSET__8ac1682c__"